import { render, staticRenderFns } from "./formgroupdate.vue?vue&type=template&id=61843927&"
import script from "./formgroupdate.vue?vue&type=script&lang=js&"
export * from "./formgroupdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports